import { UploadPanel } from "../../features/gallery/components/UploadPanel";

export default function MobileUploadSelectedFile() {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <UploadPanel mobile />
    </div>
  );
}
